import React from 'react';
import { Link } from 'react-router-dom';
import { getTitoloMedico } from '../../utils/slug';
import MedicoPhoto from '../MedicoPhoto';

const MedicoCard = ({ medico, to, onClick, secondaryLabel, secondaryOnClick }) => {
  const nome = medico.nome ?? medico.firstName ?? '';
  const cognome = medico.cognome ?? medico.lastName ?? '';
  const branca = medico.branca ?? '';
  const specializzazione = medico.specializzazione ?? '';
  const specializzazioni = medico.specializzazioni != null
    ? (Array.isArray(medico.specializzazioni) ? medico.specializzazioni.join(', ') : String(medico.specializzazioni))
    : '';
  const nomeCompleto = [nome, cognome].filter(Boolean).join(' ') || 'Medico';
  const titolo = getTitoloMedico(medico);

  const cardBody = (
    <>
      <MedicoPhoto
        src={medico.urlImg}
        alt={nomeCompleto}
        variant="card"
        className="medico-card-img-wrap"
      />
      <div className="medico-card-text">
        <h3 className="medico-card-name">
          <span className="medico-card-titolo">{titolo}</span>{' '}
          <span className="medico-card-nome-cognome">{nomeCompleto}</span>
        </h3>
        {(branca || specializzazione || specializzazioni) && (
          <div className="medico-card-spec-wrap">
            {branca && <p className="medico-card-branca">{branca}</p>}
            {(specializzazione || specializzazioni) && (
              <p className="medico-card-spec">{specializzazione || specializzazioni}</p>
            )}
          </div>
        )}
      </div>
    </>
  );

  const secondaryAction = secondaryLabel && secondaryOnClick && (
    <div className="medico-card-actions">
      <button
        type="button"
        className="medico-card-secondary-btn vc-btn vc-btn-primary vc-btn-sm"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          secondaryOnClick();
        }}
      >
        {secondaryLabel}
      </button>
    </div>
  );

  if (to) {
    return (
      <article className="medico-card">
        <Link to={to} className="medico-card-link">
          {cardBody}
        </Link>
        {secondaryAction}
      </article>
    );
  }

  const handleCardClick = (e) => {
    if (secondaryOnClick && e.target.closest('.medico-card-secondary-btn')) return;
    onClick?.();
  };

  return (
    <article
      className="medico-card medico-card--interactive"
      onClick={handleCardClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => e.key === 'Enter' && handleCardClick(e) : undefined}
    >
      <div className="medico-card-link">
        {cardBody}
      </div>
      {secondaryAction}
    </article>
  );
};

export default MedicoCard;
